import { Link, createBrowserRouter } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import HomeScreen from "./components/HomeScreen";
import Layout from "./components/Layout";
import Login from "./components/Login";
import Profile from "./components/Profile";
import BankDetails from "./components/Profile/bankDetails/bankDetails";
import EditProfile from "./components/Profile/editProfile/editProfile";
import Registration from "./components/Registration/Registration";
import CustomerBenefits from "./components/customerBenefits";
import LandingScreen from "./components/landingScreen/landingScreen";
import NoLayout from "./components/NoLayout";
import Acknowledge from "./components/Registration/Acknowledge";
import SuccessRegistration from "./components/Registration/successRegistration";
import AddToHomeScreen from "./components/Registration/addToHome";
import SetPassword from "./components/Registration/setPassword";
import HelpVideo from "./components/HelpVideo";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <HomeScreen />,
      },

      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/profile/edit-profile",
        element: <EditProfile />,
      },
      {
        path: "/profile/bank-details",
        element: <BankDetails />,
      },
      {
        path: "/customer-benefits",
        element: <CustomerBenefits />,
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
      },
      {
        path: "/help-video",
        element: <HelpVideo />,
      }
    ],
  },
  {
    path: "/",
    element: <NoLayout />,
    children: [
      {
        path: "/registration",
        element: <Registration />,
      },
      {
        path: "/acknowledge",
        element: <Acknowledge />,
      },
      {
        path: "/set-password",
        element: <SetPassword />,
      },
      {
        path: "/success-registration",
        element: <SuccessRegistration />,
      },
      {
        path: "/add-to-home",
        element: <AddToHomeScreen />,
      },
      {
        path: "/login",
        element: <Login />,
      },
    ],
  },
  {
    path: "/start",
    element: <LandingScreen />,
  },
  {
    path: "/*",
    element: (
      <div
        style={{
          background: "#f7f7f7",
          height: "100svh",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          gap: 15,
        }}
      >
        <h1 style={{ color: "#f07821" }}>Page not found!</h1>
        <h3 style={{ color: "#b6b4b4" }}>Error code: 404</h3>
        <Link to="/">
          <button
            style={{
              background: "var(--brandColor)",
              color: "#fff",
              padding: "7.5px 15px",
              letterSpacing: "1.1px",
            }}
          >
            Go Back to Home
          </button>
        </Link>
      </div>
    ),
  },
]);

export default router;
